import { SELECTED_PROJECT } from "@configuration";
import { TranslationContext } from "@contexts";
import { PageLoader } from "@features/common/ui/PageLoader";
import { useQueryAppConfiguration } from "@hooks/appConfiguration/useQueryAppConfiguration";
import { InlineIcon } from "@iconify/react";
import { useKeycloak } from "@react-keycloak/web";
import styleVariables from "@style_setup";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { Link } from "react-router-dom";
import { CartIconComp } from "./CartIconComp";
import { mainMenuItems } from "./helpers";

const styles = createUseStyles({
  MainMenuModal: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    zIndex: "9999",
  },
  overlay: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,.8)",
    zIndex: "0",
  },
  contentContr: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -60%)",
    textAlign: "end",
    width: "75vw",
  },
  content: {
    background: "white",
    padding: "2rem",
    display: "grid",
    gap: "1.7rem",
    width: "98%",
    justifyItems: "center",
    "& hr": {
      width: "50%",
      margin: "0",
    },
  },
  closeX: {
    color: "white",
    fontSize: "xxx-large",
  },
  menuItem: {
    color: "black",
    textDecoration: "none",
  },
  [`@media ${styleVariables.media.smallscreen}`]: {},
});
export const MainMenuModal = ({ setShowModal = () => {} }) => {
  const { t } = useContext(TranslationContext);

  const classes = styles({});

  const { keycloak } = useKeycloak();
  const isAuthenticated = keycloak.authenticated;
  const isSuperAdmin = keycloak.hasRealmRole("super-admin");

  const { data: configObj, isLoading } = useQueryAppConfiguration();

  function closeModal() {
    setShowModal(false);
  }

  const logout = () => {
    keycloak.logout({ redirectUri: `${window.location.origin}/` });
    closeModal();
  };

  return (
    <div className={classes.MainMenuModal}>
      <div className={classes.overlay} />
      <div className={classes.contentContr}>
        {isLoading ? (
          <PageLoader />
        ) : (
          <>
            <InlineIcon
              icon="flowbite:close-solid"
              className={classes.closeX}
              onClick={closeModal}
            />
            <div className={classes.content}>
              {isAuthenticated && (
                <>
                  {isSuperAdmin && (
                    <Link to="/back-office" className={classes.navbarItem}>
                      {t("backOffice")}
                    </Link>
                  )}
                  {mainMenuItems().map((item) => (
                    <React.Fragment key={item.arg}>
                      {!item.arg.includes("cart") && (
                        <Link
                          to={item.arg}
                          onClick={closeModal}
                          className={classes.menuItem}
                        >
                          {typeof item.title === "string"
                            ? t(item.title)
                            : item.title}
                        </Link>
                      )}

                      {configObj.hasCart && item.arg.includes("cart") && (
                        <Link
                          to={item.arg}
                          onClick={closeModal}
                          className={classes.menuItem}
                        >
                          <CartIconComp />
                        </Link>
                      )}
                    </React.Fragment>
                  ))}
                  <hr />
                  <button onClick={logout}>{t("logout")}</button>
                </>
              )}
              {/* {configObj.hasMultiLanguage && (
          )} */}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
MainMenuModal.propTypes = {
  setShowModal: PropTypes.func.isRequired,
};
